module.exports = __webpack_public_path__ + "static/img/gsbzizhi2.986ca2f8.jpg";